import { Data_getInstance4ef42n95zyko as Data_getInstance } from './adapter/SavePinMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePinMutationSelections_getInstance2cgvupvd32jxw as SavePinMutationSelections_getInstance } from './selections/SavePinMutationSelections.mjs';
import { SavePinMutation_VariablesAdapter_instance16zflwq4tc19t as SavePinMutation_VariablesAdapter_instance } from './adapter/SavePinMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePin) {
        this.savePin_1 = savePin;
      }
      toString() {
        return 'Data(savePin=' + this.savePin_1 + ')';
      }
      hashCode() {
        return this.savePin_1 == null ? 0 : getBooleanHashCode(this.savePin_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.savePin_1 == other.savePin_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ADAPTER_1 = obj(Data_getInstance());
        this.ROOT_FIELD_1 = (new (Builder())('data', Companion_getInstance().type_1)).selections_gjxob8_k$(SavePinMutationSelections_getInstance().__root_1).build_1k0s4u_k$();
        this.OPERATION_ID_1 = '16ed341f62125adac6d4641ec718698f5efb684fe32af3e92d15f74176c9023c';
        this.OPERATION_NAME_1 = 'savePin';
      }
      get_OPERATION_DOCUMENT_t250nw_k$() {
        return 'mutation savePin($input: SavePinInput!) { savePin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePinMutationClass;
function SavePinMutation() {
  if (SavePinMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.input_1 = input;
      }
      operationId_2580de_k$() {
        return '16ed341f62125adac6d4641ec718698f5efb684fe32af3e92d15f74176c9023c';
      }
      operationId() {
        return this.operationId_2580de_k$();
      }
      document_e91o2j_k$() {
        return Companion_getInstance_0().get_OPERATION_DOCUMENT_t250nw_k$();
      }
      operationName_1injiq_k$() {
        return 'savePin';
      }
      operationName() {
        return this.operationName_1injiq_k$();
      }
      serializeVariables_bugef7_k$(writer, customScalarAdapters, withDefaultValues) {
        SavePinMutation_VariablesAdapter_instance.serializeVariables_k0mdpj_k$(writer, this, customScalarAdapters, withDefaultValues);
      }
      adapter_j0zdtd_k$() {
        return Companion_getInstance_0().ADAPTER_1;
      }
      toString() {
        return 'SavePinMutation(input=' + this.input_1.toString() + ')';
      }
      hashCode() {
        return this.input_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinMutation()))
          return false;
        if (!this.input_1.equals(other.input_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinMutation', VOID, VOID, [Mutation()]);
    SavePinMutationClass = $;
  }
  return SavePinMutationClass;
}
//region block: exports
export {
  Data as Datagefyj3dojvb5,
  SavePinMutation as SavePinMutation3865jhueq4vmv,
};
//endregion

//# sourceMappingURL=SavePinMutation.mjs.map
